import { render, staticRenderFns } from "./InsightsTable.vue?vue&type=template&id=6de32fd4"
import script from "./InsightsTable.vue?vue&type=script&lang=js"
export * from "./InsightsTable.vue?vue&type=script&lang=js"
import style0 from "./InsightsTable.vue?vue&type=style&index=0&id=6de32fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports